import { HTMLElementConvertOption } from '@lumapps/wrex/serialization/html/fromHTML/types';
import { matchNode } from '@lumapps/wrex/serialization/html/fromHTML/utils';

import { TABLE, T_D, T_H, T_R } from '../../../constants';
import { createTable } from '../../../utils/createTable';
import { createTD } from '../../../utils/createTD';
import { createTH } from '../../../utils/createTH';
import { createTR } from '../../../utils/createTR';

type ElementTypes = typeof TABLE | typeof T_R | typeof T_D | typeof T_H;

/**
 * Element convert options.
 *
 * Warning: the order of these options does matter!
 */
export const ELEMENTS: { [Element in ElementTypes]: HTMLElementConvertOption<Element> } = {
    table: {
        test: matchNode({ tagName: 'table' }),

        type: TABLE,
        transform: (node, children) => createTable({}, children),
    },
    tr: {
        test: matchNode({ tagName: 'tr' }),
        type: T_R,
        transform: (node, children) => createTR(children),
    },
    td: {
        test: matchNode({ tagName: 'td' }),
        type: T_D,
        transform: (node, children) => createTD(children),
    },
    th: {
        test: matchNode({ tagName: 'th' }),
        type: T_H,
        transform: (node, children) => createTH(children),
    },
};
